import React, { Component } from 'react';
import logo from './logo.svg';
import './App.scss';
import Map from './map/Map'

class App extends Component {
  render() {
    return (
        <div>
          <header>
            <div className="row">
              <div className="column">
                <h1 className="logo">fuerza<span className="dlb">dlb</span></h1>
                <div className="phone">1 (817) 504-4270</div>
                <div className="address">
                    <span>615 W. Main St.</span>
                    <span>Arlington, TX</span>
                    <span>76010</span>
                </div>
              </div>
            </div>
          </header>
          <section id="main">
            <div className="banner">
              <div className="row">
                <div className="column">
                  <span>"Fuerza de los Barrios is helping families to learn from each other and to live better."</span>
                </div>
              </div>
            </div>
            <div className="row priority">
              <div className="columns large-6">
                <div id="children"></div>
              </div>
              <div className="columns large-6">
                <Map/>
              </div>
            </div>
            <div className="informational">
              <div className="row">
                <div className="column">
                  <p>Creating nurturing environments for children promotes healthy development and can prevent mental, emotional and behavioral problems. However, it is not unusual for children to sometimes develop problems during childhood that, like a broken bone, should be attended to and set properly so they can grow stronger into adulthood.</p>
                  <p>Counseling sessions are focused on individual growth and understanding in the context of family, education and community. Our goal is to help every child achieve knowledge and realization of their responsibility for the important role they play in shaping their own future and the role they play in shaping a positive, growth oriented community.</p>
                  <p>We provide counseling in English and Spanish for the general community, with a focus on Spanish language services. We accept clients with limited income.</p>
                </div>
              </div>
            </div>
          </section>
          <footer>
            <div className="row">
              <div className="column large-4">
                <div className="house">
                  <div className="family-house"></div>
                  <span className="h2 share">Share</span>
                  <span className="h2 learn">Learn</span>
                  <span className="h2 grow">Grow</span>
                </div>
              </div>
              <div className="column large-4">
                <p>By working to bring people together into community discussions, we hope to foster positive attitudes towards mental health as a sign of community health.</p>
                <p>Effective family, school and community programs can help children and their families. Treating children when the first signs of a problem appear is important because what happens in childhood can affect a person for a lifetime.</p>
                <h3 className="logo">fuerza<span className="dlb">dlb</span></h3>
              </div>
              <div className="column large-4">
                <p className="info">
                  <span>Fuerza de Los Barrios</span>
                  <span>Jose&#769; Gonzales, M.S.W.</span>
                  <span className="phone">1 (817) 504-4270</span>
                  <br/>
                  <span className="address">
                    <span>615 W. Main St.</span>
                    <span>Arlington, TX</span>
                    <span>76010</span>
                  </span>
                </p>
              </div>
            </div>
          </footer>
        </div>
    );
  }
}

export default App;
